import { useEffect, useRef } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { useGqlUserScrapCountsQuery, UserScrapType } from 'generated/graphql'
import { TabType } from '@app.components/tabs/CardTabs/CardTabs'
import { COMPANY, COMPANY_ANALYSIS } from '../screen/ScreenScrap.mobile'

const ScrapTabMobile = () => {
  const router = useRouter()
  const tabRef = useRef<Record<string, HTMLAnchorElement | null>>({})

  const scrollToTabByName = (tabName: string) => {
    const tab = tabRef.current[tabName]
    if (tab) {
      tab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }
  const scrollToTab = (tabName: string) => () => scrollToTabByName(tabName)

  const { data, refetch } = useGqlUserScrapCountsQuery({
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    refetch()
  }, [router.query.tab])

  const activityCounts = data?.userScrapCounts?.activityCounts || 0
  const companyCounts = data?.userScrapCounts?.companyInfoCounts || 0
  const coverLetterCounts =
    data?.userScrapCounts?.coverLetterAndParagraphCounts || 0
  const communityCounts = data?.currentUserScrapsCountCommunity || 0
  const newsItemCounts = data?.userScrapCounts?.newsItemCounts || 0
  const analysisCount = data?.viewerScrappedAnalysisReports.totalCount || 0

  const tabs: TabType[] = [
    {
      id: 0,
      name: `공고`,
      count: activityCounts,
      href: {
        query: { tab: UserScrapType.ACTIVITY },
      },
    },
    {
      id: 1,
      name: '관심기업',
      count: companyCounts,
      href: {
        query: { tab: COMPANY },
      },
    },
    {
      id: 2,
      name: `합격자소서`,
      count: coverLetterCounts,
      href: {
        query: { tab: UserScrapType.COVER_LETTER_AND_PARAGRAPH },
      },
    },
    {
      id: 3,
      name: `커뮤니티`,
      count: communityCounts,
      href: {
        query: { tab: UserScrapType.COMMUNITY },
      },
    },
    {
      id: 4,
      name: `채널소식`,
      count: newsItemCounts,
      href: {
        query: { tab: UserScrapType.NEWS_ITEM },
      },
    },
    {
      id: 5,
      name: `기업분석자료`,
      count: analysisCount,
      href: {
        query: { tab: COMPANY_ANALYSIS },
      },
    },
  ]

  return (
    <StyledWrapper>
      {tabs.map((tab) => {
        const tabQuery = router.query.tab ?? UserScrapType.ACTIVITY
        return (
          <Link key={tab.id} href={tab.href || ''}>
            <a
              className="menu"
              data-active={tabQuery === tab.href?.query.tab}
              ref={(elem) => (tabRef.current[tab.href?.query.tab || ''] = elem)}
              onClick={scrollToTab(tab.href?.query.tab || '')}
            >
              {tab.name} {`(${tab.count || 0})`}
            </a>
          </Link>
        )
      })}
    </StyledWrapper>
  )
}

export default ScrapTabMobile

const StyledWrapper = styled.div`
  display: flex;
  gap: 15px;
  padding: 13px 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
  overflow-x: auto;
  white-space: nowrap;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .menu {
    color: #999;
    &[data-active='true'] {
      color: black;
    }
  }
`
